import { MixPanelAdapter } from "../../adpters/MixPanelAdapter/MixPanelAdapter";

/** O que o aviso de cookies liga e desliga: a análise de uso (Mixpanel). */
export const analyticsTargets = {
    optIn() {
        new MixPanelAdapter().optIn();
    },
    optOut() {
        new MixPanelAdapter().optOut();
    }
};
